import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "bg-surface-light py-1" }
const _hoisted_3 = {
  colspan: "100",
  class: "px-4 py-2"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_AddAccountDialog = _resolveComponent("AddAccountDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_EditAccountDialog = _resolveComponent("EditAccountDialog")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "d-flex align-center justify-content-between" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", {
                        class: "pl-3",
                        textContent: _toDisplayString(_ctx.$t('praxisgruppe.einstellungen.benutzer.list.title'))
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AddAccountDialog)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_data_table, {
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expanded) = $event)),
            "sort-by": _ctx.sortBy,
            "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sortBy) = $event)),
            headers: _ctx.headers,
            items: _ctx.benutzerList,
            "item-value": "id",
            "show-expand": "",
            class: "elevation-1",
            "single-expand": "",
            "disable-pagination": "",
            "hide-default-footer": "",
            "must-sort": true,
            hover: "",
            "items-per-page": -1,
            "onClick:row": _ctx.expandRow
          }, {
            "item.burgermenu": _withCtx(({ item }) => [
              _createVNode(_component_v_menu, {
                modelValue: item.burgermenuActive,
                "onUpdate:modelValue": ($event: any) => ((item.burgermenuActive) = $event),
                "offset-x": ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({
                    icon: "",
                    flat: "",
                    href: item.burgermenu
                  }, props), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        icon: "mdi-menu"
                      })
                    ]),
                    _: 2
                  }, 1040, ["href"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditAccountDialog, {
                        "edit-benutzer-id": item.id,
                        onSuccess: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = []))
                      }, null, 8, ["edit-benutzer-id"]),
                      _createVNode(_component_ConfirmDialog, {
                        title: "einstellungen.deletedialog.title",
                        text: "einstellungen.deletedialog.text",
                        onConfirm: ($event: any) => (_ctx.deleteBenutzer(item.id))
                      }, {
                        activatorElement: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                textContent: _toDisplayString(_ctx.$t('table.burgermenu.delete'))
                              }, null, 8, ["textContent"])
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"]),
                      _createVNode(_component_ConfirmDialog, {
                        title: "einstellungen.resetmfa.title",
                        text: "einstellungen.resetmfa.text",
                        onConfirm: ($event: any) => (_ctx.resetMfa(item.id))
                      }, {
                        activatorElement: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                textContent: _toDisplayString(_ctx.$t('table.burgermenu.resetmfa'))
                              }, null, 8, ["textContent"])
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            "item.data-table-expand": _withCtx(({ item }) => [
              _createVNode(_component_v_btn, {
                icon: "",
                class: "elevation-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isRowExpanded(item) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            "expanded-row": _withCtx(({}) => [
              _createElementVNode("tr", _hoisted_2, [
                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "d-none d-md-table-cell" }, null, -1)),
                _createElementVNode("td", _hoisted_3, [
                  _createVNode(_component_v_row, { class: "d-flex flex-wrap" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('einstellungen.benutzer.rollen') + ' '), 1),
                          (_ctx.benutzerDetails.rollen)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('benutzerrollen.' + _ctx.benutzerDetails.rollen.toString().toLowerCase())), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('einstellungen.benutzer.mobile') + ' '), 1),
                          (_ctx.benutzerDetails.mobilNummer)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.benutzerDetails.mobilNummer), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["expanded", "sort-by", "headers", "items", "onClick:row"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}